import React, { useState, useEffect } from "react";
import {
  Menu,
  Select,
  Radio,
  Tag,
  Space,
  Row,
  Col
} from "antd";
import { Checkbox } from 'antd';

import { useDispatch, useSelector } from "react-redux";
import '../ExperienceLevelFilter/ExperienceFilter.css';
import { LoadingOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";



const ExperienceLevelFilter = (props) => {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  const { id, name } = useParams();
  //const [check, setCheck] = useState();
  const filters = useSelector(state => state.searchSkillListingReducer.filters);
  const count = useSelector(state => state.searchSkillListingReducer.skillListings);

  const Count = useSelector(
    (state) => state.searchSkillListingReducer.skillListingCount
  );

  const countLoading = useSelector(
    (state) => state.searchSkillListingReducer.countLoading
  ); 
 
  const onExperienceRadioClicked = (e) => {
    //setCheck(e.target.value);
    props.setcheck(e.target.value);
  }
  const onChange = (checkedValues) => {
    props.setCheckedBox(checkedValues)
  };

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const countFromValue = (item) => {
    const matchingCount = Count?.result?.experienceCount?.find(
      (count) => count?.title === item
    );
    const count = matchingCount ? matchingCount.count : 0;
    return count
  }


  return (
    <Checkbox.Group
    style={{ marginBottom: '5%', width: '100%' }}
    onChange={onChange}
    value={props?.checkBox}
    >
    <Space direction="vertical" style={{ width: '100%' }}>
      <div className="radios mob-exp-lvl-div" style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between' }}>
          <Checkbox value="Less than 1 year">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "inherit",
              }}
            >
              <div>Less than 1 year</div>
              <div className='countDiv'>{id || props?.fromCandMkt ? null : "(" + (countFromValue("Less than 1 year")) + ")"}</div>
            </div>
          </Checkbox>
        </div>
      <div className="radios mob-exp-lvl-div" style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between' }}>
          <Checkbox value="1-2 years">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "inherit",
              }}
            >
              <div>1-2 years</div>
              <div className='countDiv'>{id || props?.fromCandMkt ? null :  "(" + (countFromValue("1-2 years")) + ")"}</div>
            </div>
          </Checkbox>
        </div>
        <div className="radios mob-exp-lvl-div" style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between' }}>
          <Checkbox value="3-5 years">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "inherit",
              }}
            >
              <div>3-5 years</div>
              <div className='countDiv'>{id || props?.fromCandMkt ? null : "(" + (countFromValue("3-5 years")) + ")"}</div>
            </div>
          </Checkbox>
        </div>
      <div className="radios mob-exp-lvl-div" style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between' }}>

          <Checkbox value="6-10 years">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "inherit",
              }}
            >
              <div>6-10 years</div>
              <div className='countDiv'>{id || props?.fromCandMkt ? null : "("+(countFromValue("6-10 years"))+")"}</div>
            </div>
          </Checkbox>
      </div>
      <div className="radios mob-exp-lvl-div" style={{ display: 'flex', flexDirection: "row", justifyContent: 'space-between' }}>

        <Checkbox value="More than 10 years">
        <div
        style={{
                display: "flex",
                justifyContent: "space-between",
                width: "inherit",
              }}
        >
          <div>More than 10 years</div>
          <div className='countDiv'>{id || props?.fromCandMkt ? null : "("+(countFromValue("More than 10 years"))+")"}</div>
        </div>
        
        </Checkbox>
      </div>
    </Space>
  </Checkbox.Group>

  )
}


export default ExperienceLevelFilter;

